<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <ModuleShell
    :title="title"
    :icon="icon"
    :compact="true"
    :clickable="true"
    @click="handleClick"
  >
    <!-- Map extra slot to ModuleShell's action slot -->
    <template #action>
      <slot name="extra" />
    </template>
  </ModuleShell>
</template>

<script setup>
import { useRouter } from 'vue-router'
import ModuleShell from '@/components/ui/layout/ModuleShell.vue'

const props = defineProps({
  icon: { type: [Object, Function], required: true },
  title: { type: String, required: true },
  to: { type: String, default: null },
  danger: { type: Boolean, default: false },
})

const emit = defineEmits(['click'])
const router = useRouter()

function handleClick() {
  emit('click')
  if (props.to) {
    router.push(props.to)
  }
}
</script>
